import React from "react";
import styled from "styled-components";
import { MyPageHead } from "../myPage/common";

const CommunityGuideLine = () => {
  return (
    <GuideContainer>
      <MyPageHead title="커뮤니티 가이드라인" />
      <GuideSection>
        <h2>
          플로리스트만의 커뮤니티, <br />
          플로웨이의 커뮤니티 가이드라인🌷
        </h2>
        <p>
          플로웨이 커뮤니티는 요즘 꽃 디자인, 꽃집 운영 등, 화훼 업계 관련
          이야기를 플로리스트끼리 나누고, 유용한 정보를 공유할 수 있도록 마련한
          공간이에요.
        </p>
        <p>
          모두에게 유용하고 깨끗한 커뮤니티가 될 수 있도록, 아래 가이드라인을
          반드시 지켜주세요.
        </p>
        <p>
          만약 가이드라인을 지키지 않는 글이 보이면 신고 기능을 이용해주세요.
        </p>
        <h3>서로를 배려하고, 존중해주세요</h3>
        <ol>
          <li>
            플로리스트끼리 도움이 될 수 있는 이야기, 콘텐츠를 공유해주세요.
          </li>
          <li>
            도움을 받았다면, 받은 만큼 유용한 정보를 다른 분들께도 공유해주시면
            좋을 것 같아요.
          </li>
          <li>상호 존중하는 말을 사용해 주세요.</li>
          <li>욕설, 비방은 삼가주세요. 성희롱은 더 엄격하게 관리돼요.</li>
        </ol>
        <h3>스팸이나 남을 속이면 안돼요</h3>
        <ol>
          <li>광고, 홍보 목적의 글은 남길 수 없어요.</li>
          <li>음란물로 여겨질 수 있는 글 역시 게시할 수 없어요.</li>
          <li>확인되지 않은 이야기로 갈등을 조장하지 말아주세요.</li>
          <li>사기를 치거나 남을 의도적으로 속이는 것 역시 안돼요.</li>
        </ol>
        <h3>가이드라인을 지키지 않는 글은 신고, 삭제돼요</h3>
        <ol>
          <li>
            언제든지 가이드라인을 지키지 않으면 신고해 주세요. 영업일 시준 7일
            이내 관리자 검토 후, 글 삭제 및 회원탈퇴 처리할게요.
          </li>
          <li>
            가이드라인을 지키지 않으면 신고가 없어도 통보 없이 글 삭제 및 회원
            탈퇴될 수 있어요.
          </li>
        </ol>
      </GuideSection>
    </GuideContainer>
  );
};

export default CommunityGuideLine;

const GuideContainer = styled.section``;

const GuideSection = styled.div`
  padding: 16px;

  h2 {
    font-weight: 700;
    font-size: 20px;
    color: #222529;
  }

  h3 {
    font-weight: 700;
    font-size: 16px;
    margin-top: 16px;
  }

  p,
  li {
    font-weight: 400;
    font-size: 14px;
    color: #4a5056;
  }

  ol {
    padding: 0 16px;
  }

  p {
    margin-top: 12px;
  }

  li {
    list-style: disc;
    margin-top: 12px;
  }
`;
